export const environment = {
production: true,
    productRootPath: 'alamo',
    baseUrl: 'https://trademx-qa.gruposti.dev',
    cdn: 'https://trademx-cdn-qa.gruposti.dev/assets',
    allowedLanguages: ['es', 'en'],
    debugBreakpoints: false,
    channel: 'web',
    recaptcha: {
        siteKey: '6LcR1gckAAAAALIbBiDSmrBfkNJVlLp3mcsRjBT1',
    },
    googleTagManager: {
        id: 'GTM-P5M8XD6M',
    },
    alamoApi: {
        BASE_HOST: 'https://api-public-trademx-gw-qa.gruposti.dev',
        ENDPOINTS: {
            doReservation: 'v1/reservation',
            searchSchedules: 'v1/search/schedules/{id}',
            searchAvailability: 'v1/search/branch',
            searchAvailabilityInternational: 'v1/search/availability',
            locations: 'v1/search/branch',
            extras: 'v1/extra',
            cart: 'v1/cart/self/{sessionId}',
            cartInternational: 'v1/cart/international/self/extras',
            cartVehicle: 'v1/cart/self/vehicle',
            cartInsurance: 'v1/cart/self/insurance',
            cartProducts: 'v1/cart/self/products',
            branchs: 'alamo/availability',
            branchesInt: 'alamo/braches/international',
            branchsByOffice: 'alamo/international/availability',
            details: 'v1/reservation',
            countries: 'v1/address/self/country',
            states: 'v1/address/self/state/{countryId}',
            cities: 'v1/address/self/city/{stateId}',
            neighborhoods: 'v1/address/self/suburb/{cityId}',
            preCheckInSendData: 'v1/user',
            checkReservation: 'v1/reservation/self/exist',
            summary: 'v1/cart/self/{sessionId}/summary',
            loginGuest: 'v1/user/login',
            loginUser: 'v1/user/login',
            user: 'v1/user/{userId}',
            blogs: 'v1/resources/popular-news',
            faqs: 'v1/resources/faq',
            popularDestinations: 'v1/resources/popular-destinations',
            formCustomerSupport: 'v1/client-support',
            formCustomerSupportIssues: 'v1/resources/issues',
            formCustomerSupportOffices: 'v1/resources/offices',
            featuredPromotions: 'v1/resources/popular-promotions',
            destinations: 'v1/resources/destinations',
            citiesDestinations: 'v1/resources/cities',
            countDestinations: 'v1/resources/count-destinations',
            cityDetails: 'v1/resources/cities',
            promotionDetail: 'v1/resources/popular-promotions',
            locationDetails: 'v1/resources/destinations',
            carousel: 'v1/resources/promotions',
            subscription: 'v1/subscription',
            reservationPreCheckIn: 'v1/reservation/user',
            crp: 'v1/resources/crp',
            categoryUpdateSummary: 'v1/cart/self/categoryUpdateSummary',
            landingRewards: 'v1/resources/landing-rewards',
            resourceCountries: 'v1/resources/countries',
        },
        BASE_HOST2: 'https://demo4585469.mockable.io',
    },
    alamoRewards:
        'https://alamo.us15.list-manage.com/subscribe/post?u=df561e02dec04355ee8a75cb5&id=8b7d5c623c&f_id=001fc7e1f0',
    hbsptform: {
        region: 'na1',
        portalId: '40099200',
        formId: '1c5ca158-1629-4822-b95e-3a886a296885',
    },
    hbsptformnew: {
        region: 'na1',
        portalId: '40099200',
        formId: 'a777ee35-7206-4871-b0d6-44023d4e463e',
    },
    hbsptformennew: {
        region: 'na1',
        portalId: '40099200',
        formId: 'be84090c-4d5a-46d4-b976-83f3bf583ee3',
    },
     siteUrl: 'https://trademx-qa.gruposti.dev',
};
